/* import __COLOCATED_TEMPLATE__ from './bulk-clear-schedule-publish-modal.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  onClose: () => void;
  onConfirm: () => void;
  isBulkActionRunning: boolean;
}

const BulkClearSchedulePublishModal = templateOnlyComponent<Args>();
export default BulkClearSchedulePublishModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::BulkActions::BulkClearSchedulePublishModal': typeof BulkClearSchedulePublishModal;
    'knowledge-hub/filterable-list/bulk-actions/bulk-clear-schedule-publish-modal': typeof BulkClearSchedulePublishModal;
  }
}
